import React from "react";
import moment from "moment";
import { isEmpty } from "lodash";
import { Text4, Text5 } from "../../styles";
import { printRupee } from "../../app_methods";
import { Icon, Button, Badge, Popover, Popconfirm, Menu, Dropdown, Tag, Form, Select, Input, InputNumber } from "antd";
import {
    SMART_COLLECT_TRANSACTIONS_STATUS_TYPES,
    PAYMENT_METHODS,
    DISBURSEMENTS_STATUS_TYPES,
    DISBURSEMENTS_TYPES,
    SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES,
    SPLIT_APPROVAL_STATUS_TYPES,
} from "../../constants";
import { faRupeeSign } from "@fortawesome/free-solid-svg-icons/faRupeeSign";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PermissionHoc } from "../HOC";
import { Tooltip } from "antd";
import { SplitAccountModel } from "../../models/split_account";

const PermissableMenu = PermissionHoc(Menu.Item, null, { is_component: true, fallbackComponent: null });

export const CAPTURE_MODES = {
    dashboard: "Dashboard",
    api: "API",
    webhook: "Webhook",
};

export const renderMenuOverlay = (methods, record) => {
    return (
        <Menu>
            <PermissableMenu
                required_permission="IC_CVA_READ"
                onClick={() => methods.toggleDetailsDrawer({ ...record })}
            >
                <Icon type="eye" /> {"View Details"}
            </PermissableMenu>
            <PermissableMenu
                required_permission="IC_CVA_TRANSACTIONS_READ"
                onClick={() => methods.showVATransactions({ ...record })}
            >
                <FontAwesomeIcon icon={faRupeeSign} size="xs" /> &nbsp;&nbsp;&nbsp;{"View Transactions"}
            </PermissableMenu>
            <PermissableMenu
                required_permission="IC_CVA_INSIGHTS_READ"
                onClick={() => methods.toggleInsightsDrawer({ ...record })}
            >
                <Icon type="line-chart" /> {"View Insights"}
            </PermissableMenu>
            {!record.is_submerchant ? (
                <PermissableMenu
                    required_permission="IC_CVA_WRITE"
                    onClick={() => methods.toggleVirtualAccountModal({ ...record, is_edit: true })}
                >
                    <Icon type="edit" /> {"Edit Details"}
                </PermissableMenu>
            ) : null}
            {/* {!record.is_submerchant &&
            record.enable_cva_balance_maintenance &&
            (record.ecvabm ? record.ecvabm : false) ? (
                <PermissableMenu
                    required_permission="IC_CVA_WRITE"
                    onClick={() => methods.toggleSettlementModal({ ...record })}
                    disabled={record.usable_balance.toFixed(2) <= 0 ? true : false}
                >
                    <Icon type="wallet" /> {"Settle"}
                </PermissableMenu>
            ) : null} */}
            {(!record.is_submerchant && record?.split_settlement_type == "CVA" && record?.enable_split_settlements) ?
            (<PermissableMenu
                required_permission="IC_CVA_READ"
                onClick={() => methods.togglesplitModal({...record})}
            >
                <Icon type="setting" /> {"Configure Split Accounts"}
            </PermissableMenu>):null}
            {!record.is_submerchant ? (
                <PermissableMenu required_permission="IC_CVA_WRITE" onClick={() => methods.updateStatus({ ...record })}>
                    {record.is_active ? (
                        <>
                            <Icon style={{ color: "red" }} type="close-circle-o" />
                            Deactivate
                        </>
                    ) : (
                        <>
                            <Icon style={{ color: "green" }} type="check-circle-o" />
                            Activate
                        </>
                    )}
                </PermissableMenu>
            ) : null}
        </Menu>
    );
};

export const renderDisbursementMenuOverlay = (methods, record) => {
    return (
        <Menu>
            <Menu.Item
                onClick={() => methods.toggleDisbursementDetailsDrawer({ ...record })}
            >
                 {"View Details"}
            </Menu.Item>
            {record.disbursement_type == "settlement" && record.status == "success" && record.enable_settlement_report_download &&
            <Menu.Item
                onClick={() => methods.downloadSettlementReport({ ...record })}
            >
                {"Download Report"}
            </Menu.Item>}
        </Menu>
    );
};

export const getVirtualAccountTableColumns = (ecvabm, methods) => {
    let columns = [
        {
            title: "Label",
            key: "label",
            width: "25%",
            render: (record) => (
                <Button
                    style={{ whiteSpace: "pre-wrap", textAlign: "left" }}
                    onClick={() => methods.toggleDetailsDrawer({ ...record })}
                    type="link"
                    className="pl-0 font-monospace"
                    disabled={record.is_submerchant}
                >
                    {record.label}
                </Button>
            ),
        },
        // {
        //     title: "Created At",
        //     key: "created_at",
        //     render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>
        // },  as per disscusion with satyam
        {
            title: "Description",
            key: "description",
            width: "50%",
            ellipsis: true,
            render: (record) => (
                <div style={{ display: "contents", whiteSpace: "pre-wrap", textAlign: "left" }}>
                    <Text4>{record.description || "---"}</Text4>
                </div>
            ),
        },
        {
            title: "Status",
            key: "is_active",
            render: (record) => (
                <div>
                    <Text4>
                        <Badge
                            color={record.is_active ? "green" : "red"}
                            text={<Text4>{record.is_active ? "Active" : "Inactive"}</Text4>}
                        />
                    </Text4>
                </div>
            ),
        },
        {
            title: "Actions",
            render: (record) => (
                <Dropdown overlay={renderMenuOverlay(methods, record)}>
                    <Button>
                        Actions <Icon type="down" />
                    </Button>
                </Dropdown>
            ),
        },
    ];
    if (ecvabm) {
        columns.splice(1, 0, {
            title: "Balance",
            key: "usable_balance",
            render: (record) => <Text4>{printRupee(record.usable_balance,3)}</Text4>,
        });
    }
    return columns;
};

export const getVirtualAccountTransactionTableColumns = (methods) => [
    {
        title: "Created At",
        key: "created_at",
        render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>,
    },
    {
        title: "Virtual Account",
        key: "virtual_account",
        render: (record) => (
            <div>
                <Text4 className="d-block" style={{ width: "300px", overflowWrap: "break-word", textAlign: "left" }}>
                    {record.virtual_account.label}
                </Text4>
                <Text4 className="d-block" secondary>
                    {record.payment_mode == "UPI"
                        ? record.virtual_account.virtual_upi_handle
                        : record.virtual_account.virtual_account_number}
                </Text4>
            </div>
        ),
    },
    {
        title: "Remitter",
        key: "remitter_account_name",
        render: (record) => (
            <div>
                <Text4 className="d-block">{record.remitter_full_name}</Text4>
                <Text4 className="d-block overflow-ellipsis" secondary>
                    {record.payment_mode == "UPI" ? record.remitter_upi_handle : record.remitter_account_number}
                </Text4>
            </div>
        ),
    },
    {
        title: "Amount",
        key: "amount",
        render: (record) => <Text4>{printRupee(record.amount)}</Text4>,
    },
    {
        title: "UTR",
        key: "unique_transaction_reference",
        render: (record) => (
            <div>
                <Text4>{record.unique_transaction_reference || "---"}</Text4>
            </div>
        ),
    },
    {
        title: (
            <span className="c-pointer" onClick={methods.setShowStatusInfoDrawer}>
                <span>Status</span>
                <Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" />
            </span>
        ),
        key: "status",
        render: (record) => (
            <div style={{ width: "max-content" }}>
                <Text4>
                    <Badge
                        color={SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[record.status].color}
                        text={<Text4>{SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[record.status].label}</Text4>}
                    />
                </Text4>
                {!isEmpty(record?.hold_details) ? (
                    <Tooltip title="Transaction on Hold">
                        <Icon style={{ fontSize: 14, color: "#ff4d4f"}} className="ml-1" type="info-circle" />
                    </Tooltip>
                ) : null}
            </div>
        ),
    },
    {
        title: "Payment Mode",
        key: "payment_mode",
        render: (record) => (
            <Text4>{record.payment_mode}</Text4>
        ),
    },
    {
        title: "Actions",
        render: (record) => (
            <Button
                type="link"
                style={{ paddingLeft: "0px" }}
                onClick={() => methods.toggleTransactionDetailsDrawer(record)}
            >
                View Details
            </Button>
        ),
    },
];

export const getDisbursementsTableColumns = (methods, enable_settlement_mapping_report) => [
    {
        title: "Created At",
        key: "created_at",
        render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>,
    },
    {
        title: "Beneficiary Details",
        key: "beneficiary_account_name",
        render: (record) => (
            <div>
                <Text4 className="d-block">{record.beneficiary_account_name}</Text4>
                <Text4 className="d-block" secondary>
                    {record.payment_mode == "UPI" ? record.beneficiary_upi_handle : record.beneficiary_account_number}
                </Text4>
            </div>
        ),
    },
    {
        title: "Amount",
        key: "amount",
        render: (record) => (
            <div>
                <Text4>{printRupee(record.amount, 2) || "---"}</Text4>
            </div>
        ),
    },
    {
        title: "UTR",
        key: "unique_transaction_reference",
        render: (record) => (
            <div>
                <Text4>{record.unique_transaction_reference || "---"}</Text4>
            </div>
        ),
    },
    {
        title: "Type",
        key: "disbursement_type",
        render: (record) => (
            <div>
                {
                    <>
                        <Tag
                            style={{ width: 110, textAlign: "center" }}
                            color={DISBURSEMENTS_TYPES[record?.disbursement_type]?.color}
                        >
                            {DISBURSEMENTS_TYPES[record.disbursement_type]?.label}
                        </Tag>
                        {record.via_capture_flow && (
                            <Tooltip title="Auto refunded via transaction capture flow." trigger="hover">
                                <Icon style={{ fontSize: 14, color: "red" }} className="ml-1" type="info-circle" />
                            </Tooltip>
                        )}
                    </>
                    // <Text4><Badge color={DISBURSEMENTS_TYPES[record.disbursement_type].color} text={<Text4>{DISBURSEMENTS_TYPES[record.disbursement_type].label}</Text4>} /></Text4>
                }
            </div>
        ),
    },
    {
        title: (
            <span className="c-pointer" onClick={methods.setShowStatusInfoDrawer}>
                <span>Status</span>
            </span>
        ),
        key: "status",
        render: (record) => (
            <div>
                {
                    <Text4>
                        <Badge
                            color={DISBURSEMENTS_STATUS_TYPES[record.status].color}
                            text={<Text4>{DISBURSEMENTS_STATUS_TYPES[record.status].label}</Text4>}
                        />
                    </Text4>
                }
            </div>
        ),
    },
    {
        title: "Actions",
        render: (record) => (
            enable_settlement_mapping_report?
            <Dropdown overlay={renderDisbursementMenuOverlay(methods, record)}>
                    <Button>
                        Actions <Icon type="down" />
                    </Button>
                </Dropdown>
            :
            <Button
                type="link"
                style={{ paddingLeft: "0px" }}
                onClick={() => methods.toggleDisbursementDetailsDrawer(record)}
            >
                View Details
            </Button>
        ),
    },
];

export const virtualAccountFilterNodes = (current_user) => {
    let nodes = [
        {
            label: "Virtual Account Number",
            field: "virtual_account_number",
            placeholder: "Enter Virtual Account Number",
            inputType: "text",
            defaultValue: "",
            width: 200,
        },
        {
            label: "Label",
            field: "label",
            placeholder: "Enter Label",
            inputType: "text",
            defaultValue: "",
        },
        {
            label: "Status",
            field: "is_active",
            placeholder: "Select Status",
            inputType: "select",
            options: [
                {
                    key: 1,
                    value: true,
                    label: <Badge color="green" text="Active" />,
                },
                {
                    key: 2,
                    value: false,
                    label: <Badge color="red" text="Inactive" />,
                },
            ],
        },
        {
            label: "Virtual UPI Handle",
            field: "virtual_upi_handle",
            placeholder: "Enter Virtual UPI Handle",
            inputType: "text",
            defaultValue: "",
            width: 200,
        },
        {
            label: "Unique Request Number",
            field: "unique_request_number",
            placeholder: "Enter Unique Request Number",
            inputType: "text",
            defaultValue: "",
            width: 200,
        },

    ];

    if (current_user.is_reseller && current_user.esda) {
        nodes.unshift({
            label: "Merchant",
            field: "submerchant_id",
            placeholder: "Merchant ID",
            width: 250,
            inputType: "select",
            showSearch: true,
            defaultValue: undefined,
            options: current_user.submerchants
                ? current_user.submerchants.map((sub_merchant, index) => {
                      let object = {};
                      object.key = index;
                      object.value = sub_merchant.id;
                      object.label = sub_merchant.name + " (" + sub_merchant.email + ")";
                      return object;
                  })
                : [],
        });
    }
    return nodes;
};

export const transactionFilterNodes = (params = {}, current_user, virtualAccounts, getVirtualAccounts) => {
    let nodes = [
        {
            label: "Created At",
            field: "created_at",
            placeholder: "Select Date",
            inputType: "date_range",
            defaultValue: [moment().subtract(3, "days"), moment()],
            disabledDate: moment().subtract(1, "year"),
            preventClear: true,
        },
        {
            label: "Virtual Account",
            field: "virtual_account_id",
            placeholder: "Enter Virtual Account ID",
            inputType: "select",
            defaultValue: params.virtual_account_id || "",
            options: 
                virtualAccounts?.map((va) => {
                    return { label: va.label, value: va.id };
                }),
            width: 195,
            showSearch: true,
            onSearch: getVirtualAccounts,
            searchMinLength: 3,
        },
        // {
        //     label: "Order ID",
        //     field: "order_id",
        //     placeholder: "Enter Order ID",
        //     inputType: "text",
        //     defaultValue: params.order_id || "",
        //     width: 195,
        // },
        {
            label: "Status",
            field: "status",
            placeholder: "Select Status",
            inputType: "select",
            width: 160,
            defaultValue: undefined,
            options: Object.keys(SMART_COLLECT_TRANSACTIONS_STATUS_TYPES).map((type, index) => {
                let object = {};
                object.key = index;
                object.value = type;
                object.label = (
                    <Badge
                        color={SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[type].color}
                        text={<Text4>{SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[type].label}</Text4>}
                    />
                );
                return object;
            }),
        },
        {
            label: "UTR",
            field: "unique_transaction_reference",
            placeholder: "Enter UTR",
            inputType: "text",
            defaultValue: "",
        },
    ];

    if (current_user.is_reseller && current_user.esda) {
        nodes.unshift({
            label: "Merchant",
            field: "submerchant_id",
            placeholder: "Merchant ID",
            width: 250,
            inputType: "select",
            showSearch: true,
            defaultValue: parseInt(params.submerchant_id) || undefined,
            options: [
                { key: -1, value: "ALL", label: "All Merchants" },
                ...(current_user.submerchants || []).map((sub_merchant, index) => ({
                    key: index,
                    value: sub_merchant.id,
                    label: `${sub_merchant.name} (${sub_merchant.email})`,
                })),
            ],
        });
    }

    if (current_user?.split_settlement_type!="CVA"){
        nodes.splice(2,0,{
            label: "Order ID",
            field: "order_id",
            placeholder: "Enter Order ID",
            inputType: "text",
            defaultValue: params.order_id || "",
            width: 195,
        })
        
    }

    return nodes;
};

export const disbursementFilterNodes = (current_user) => {
    let nodes = [
        {
            label: "Created At",
            field: "created_at",
            placeholder: "Select Date",
            inputType: "date_range",
            defaultValue: [moment().subtract(3, "days"), moment()],
            preventClear: true,
            disabledDate: moment().subtract(1, "year"),
        },
        {
            label: "Status",
            field: "status",
            placeholder: "Select Status",
            inputType: "select",
            defaultValue: undefined,
            options: Object.keys(DISBURSEMENTS_STATUS_TYPES).map((type, index) => {
                let object = {};
                object.key = index;
                object.value = type;
                object.label = (
                    <Badge
                        color={DISBURSEMENTS_STATUS_TYPES[type].color}
                        text={<Text4>{DISBURSEMENTS_STATUS_TYPES[type].label}</Text4>}
                    />
                );
                return object;
            }),
        },
        {
            label: "Type",
            field: "disbursement_type",
            placeholder: "Select Type",
            inputType: "select",
            defaultValue: undefined,
            preventClear: false,
            options: Object.keys(DISBURSEMENTS_TYPES).map((type, index) => {
                let object = {};
                object.key = index;
                object.value = type;
                object.label = (
                    <Badge
                        color={DISBURSEMENTS_TYPES[type].color}
                        text={<Text4>{DISBURSEMENTS_TYPES[type].label}</Text4>}
                    />
                );
                return object;
            }),
        },
        {
            label: "UTR",
            field: "unique_transaction_reference",
            placeholder: "Enter UTR",
            inputType: "text",
            defaultValue: "",
        },
    ];

    if (current_user.is_reseller && current_user.esda) {
        nodes.unshift({
            label: "Merchant",
            field: "submerchant_id",
            placeholder: "Merchant ID",
            width: 250,
            inputType: "select",
            showSearch: true,
            defaultValue: undefined,
            options: [
                { key: -1, value: "ALL", label: "All Merchants" },
                ...(current_user.submerchants || []).map((sub_merchant, index) => ({
                    key: index,
                    value: sub_merchant.id,
                    label: `${sub_merchant.name} (${sub_merchant.email})`,
                })),
            ],
        });
    }
    return nodes;
};

export const getLedgerTableColumns = (methods) => [
    {
        title: "Date",
        key: "created_at",
        render: (record) => <Text5>{moment(record.created_at).format("lll")}</Text5>,
    },
    {
        title: "Beneficiary",
        key: "beneficiary_account",
        render: (record) => (
            <div>
                <Text5>
                    {record.transaction_type == "credit"
                        ? record.beneficiary_account_number || "---"
                        : (record.beneficiary_full_name && record.beneficiary_full_name.toUpperCase()) || "---"}
                </Text5>
            </div>
        ),
    },
    {
        title: "UTR",
        key: "unique_transaction_reference",
        render: (record) => (
            <div>
                <Text5>
                    {(record.unique_transaction_reference && record.unique_transaction_reference.toUpperCase()) ||
                        "---"}
                </Text5>
            </div>
        ),
    },
    {
        title: "Narration",
        key: "narration",
        render: (record) => (
            <div>
                <Text5>{(record.narration && record.narration.toUpperCase()) || "---"}</Text5>
            </div>
        ),
    },
    {
        title: (
            <>
                Debit <Icon style={{ color: "red" }} type="arrow-up" />
            </>
        ),
        key: "debit_amount",
        render: (record) => (
            <Text5>{record.transaction_type == "debit" ? printRupee(record.transaction_amount, 3) : "---"}</Text5>
        ),
    },
    {
        title: (
            <>
                Credit <Icon style={{ color: "green" }} type="arrow-down" />
            </>
        ),
        key: "credit_amount",
        render: (record) => (
            <Text5>{record.transaction_type == "credit" ? printRupee(record.transaction_amount, 3) : "---"}</Text5>
        ),
    },
    {
        title: "Closing Balance",
        key: "closing_balance",
        render: (record) => <Text5>{printRupee(record.closing_balance, 3)}</Text5>,
    },
];

// export const ledgerTableFilterNodes = (virtual_accounts, submerchants) => [{
//         label: "Merchant",
//         field: "submerchant_id",
//         placeholder: "Merchant ID",
//         width: 250,
//         inputType: "select",
//         showSearch: true,
//         defaultValue: undefined,
//         disabled: (submerchants || []).length <= 0,
//         options: submerchants ? submerchants.map((sub_merchant, index) => {
//             let object = {};
//             object.key = index;
//             object.value = sub_merchant.id;
//             object.label = sub_merchant.name+" ("+sub_merchant.email+")"
//             return object;
//         }): []

//     },
//     {
//         label: "Account No.",
//         field: "smart_collect_virtual_account",
//         placeholder: "Select Virtual Account",
//         inputType: "select",
//         width: 200,
//         disabled: (virtual_accounts || []).length <= 1,
//         preventClear: true,
//         defaultValue: ((virtual_accounts || []).find(x => x.is_active) || {}).id,
//         options: (virtual_accounts || []).map((account, idx) => {
//             console.log('account', account)
//             return {
//                 key: idx,
//                 value: account.id,
//                 label: account.virtual_account_number
//             }
//         })
//     },
//     {
//         label: "Date",
//         field: "created_at",
//         placeholder: "Enter Date",
//         inputType: "date_range",
//         preventClear: true,
//         defaultValue: [moment().subtract(3, 'days'), moment()]
//     }, {
//         label: "Debit/Credit",
//         field: "transaction_type",
//         placeholder: "Select Transaction Type",
//         inputType: "select",
//         defaultValue: null,
//         options: [{
//             key: "1",
//             value: "debit",
//             label: "Debit"
//         }, {
//             key: "2",
//             value: "credit",
//             label: "Credit"
//         }]
//     }
// ];



export const renderOrderMenuOverlay = (methods, record) => {
    console.log(methods)
    return (
      <Menu>
        <PermissableMenu
          required_permission="IC_ORDER_READ"
          onClick={() => methods.toggleDetailsDrawer({ ...record })}
        >
          <Icon type="eye" /> {"View Details"}
        </PermissableMenu>

        {methods?.virtualAccountSettings?.enable_edit_order && [0,1].includes(record?.status) ? ( 
          <PermissableMenu
            required_permission="IC_ORDER_WRITE"
            onClick={() =>
              methods.toggleCreateOrderModal({ ...record, is_edit: true })
            }
          >
            <Icon type="edit" /> {"Edit Details"}
          </PermissableMenu>
        ) : null}
      </Menu>
    );

    // [0 , 1] created or partially completed
};

export const getTransactionOrdersTableColumns = (methods) => [
    {
        title: "Created At",
        key: "created_at",
        render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>,
    },
    {
        title: "Request Number",
        key: "merchant_request_number",
        render: (record) => <Text4>{record.merchant_request_number}</Text4>,
    },
    {
        title: "Virtual Account",
        key: "virtual_account",
        render: (record) => (
            <div>
                <Text4 className="d-block">{record.virtual_account.account_number}</Text4>
                {record.virtual_account.upi_handle ? (
                    <Text4 className="d-block" secondary>
                        {record.virtual_account.upi_handle}
                    </Text4>
                ) : null}
            </div>
        ),
    },
    {
        title: "Customer",
        key: "customer_name",
        render: (record) => (
            <div>
                <Text4 className="d-block" style={{ overflowWrap: "break-word", textAlign: "left", width: "200px" }}>
                    {record.customer_name}
                </Text4>
                <Text4
                    style={{ overflowWrap: "break-word", textAlign: "left", width: "200px" }}
                    className="d-block"
                    secondary
                >
                    {record.customer_email} ({record.customer_phone})
                </Text4>
            </div>
        ),
    },
    {
        title: "Amount",
        key: "amount",
        render: (record) => <Text4>{printRupee(record.amount, 2)}</Text4>,
    },
    {
        title: (
            <span className="c-pointer" onClick={methods.setShowStatusInfoDrawer}>
                <span>Status</span>
            </span>
        ),
        key: "status",
        render: (record) => (
            <div style={{ width: "max-content" }}>
                {
                    <Text4>
                        <Badge
                            color={SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES[record.status].color}
                            text={<Text4>{SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES[record.status].label}</Text4>}
                        />
                    </Text4>
                }
            </div>
        ),
    },
    {
        title: "Actions",
        render: (record) => (
             <Dropdown overlay={renderOrderMenuOverlay(methods, record)}>
                    <Button>
                        Actions <Icon type="down" />
                    </Button>
            </Dropdown>
        ),
    },
];

export const TransactionOrdersTableFilterNodes = (current_user) => {
    let nodes = [
        {
            label: "Date",
            field: "created_at",
            placeholder: "Enter Date",
            inputType: "date_range",
            preventClear: true,
            defaultValue: [moment().subtract(3, "days"), moment()],
            disabledDate: moment().subtract(1, "year"),
        },
        {
            label: "Request Number",
            field: "merchant_request_number",
            placeholder: "Request Number",
            inputType: "text",
            preventClear: true,
            defaultValue: "",
        },
        {
            label: "Customer Email",
            field: "customer_email",
            placeholder: "Customer Email",
            inputType: "text",
            preventClear: true,
            defaultValue: "",
        },
        {
            label: "Customer Phone",
            field: "customer_phone",
            placeholder: "Customer Phone",
            inputType: "text",
            preventClear: true,
            defaultValue: "",
        },
        {
            label: "Status",
            field: "status",
            placeholder: "Select Status",
            inputType: "select",
            defaultValue: undefined,
            options: Object.keys(SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES).map((type, index) => {
                let object = {};
                object.key = index;
                object.value = type;
                object.label = (
                    <Badge
                        color={SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES[type].color}
                        text={<Text4>{SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES[type].label}</Text4>}
                    />
                );
                return object;
            }),
        },
    ];
    if (current_user.is_reseller && current_user.esda) {
        nodes.unshift({
            label: "Merchant",
            field: "submerchant_id",
            placeholder: "Merchant ID",
            width: 250,
            inputType: "select",
            showSearch: true,
            defaultValue: undefined,
            options: current_user.submerchants
                ? current_user.submerchants.map((sub_merchant, index) => {
                      let object = {};
                      object.key = index;
                      object.value = sub_merchant.id;
                      object.label = sub_merchant.name + " (" + sub_merchant.email + ")";
                      return object;
                  })
                : [],
        });
    }

    return nodes;
};

export const getTransactionTableColumns = (methods) => [
    {
        title: "Created At",
        key: "created_at",
        render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>,
    },
    {
        title: "Remitter",
        key: "remitter_account_name",
        render: (record) => (
            <div>
                <Text4 className="d-block">{record.remitter_full_name}</Text4>
                <Text4 className="d-block" secondary>
                    {record.payment_mode == "UPI" ? record.remitter_upi_handle : record.remitter_account_number}
                </Text4>
            </div>
        ),
    },
    {
        title: "Amount",
        key: "amount",
        render: (record) => <Text4>{printRupee(record.amount)}</Text4>,
    },
    {
        title: "UTR",
        key: "unique_transaction_reference",
        render: (record) => (
            <div>
                <Text4>{record.unique_transaction_reference || "---"}</Text4>
            </div>
        ),
    },
    {
        title: (
            <span className="c-pointer" onClick={methods.setShowStatusInfoDrawer}>
                <span>Status</span>
            </span>
        ),
        key: "status",
        render: (record) => (
            <div style={{ width: "max-content" }}>
                {
                    <Text4>
                        <Badge
                            color={SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[record.status].color}
                            text={<Text4>{SMART_COLLECT_TRANSACTIONS_STATUS_TYPES[record.status].label}</Text4>}
                        />
                    </Text4>
                }
            </div>
        ),
    },
];

export const getSplitAccountColumns = (actions) => {
  const {
    // isInitialSplitType,
    // splitType,
    // form,
    // index,
    // selectedPriorities,
    // setSelectedPriorities,
    // splitAccounts,
    // approvedList,
    // split_settlement_type,
    // can_edit,
  } = actions;
//   const { getFieldDecorator } = form;
//   const validations = SplitAccountModel.validations;
//   const handleSelectItem = (index, value) => {
//     const updatedPriorities = [...selectedPriorities];
//     updatedPriorities[index] = value;
//     setSelectedPriorities(updatedPriorities);
//   };

//   const renderPriorityDropdown = (splitAccount, index) => {
//     const availablePriorities = Array.from({ length: approvedList.length }, (_, i) => i + 1).filter(
//       (num) => !selectedPriorities.includes(num) || selectedPriorities[index] === num
//     );
//     return (
//       <Form.Item className="priority-input m-0">
//         {getFieldDecorator(`config[${index}]['priority']`, {
//           initialValue: splitAccount?.priority ? splitAccount?.priority : splitAccounts.length === 1 ? 1 : null,
//           preserve: splitType === "flat" ? true : false,
//           rules: validations.priority(splitType),
//           onChange: (value) => handleSelectItem(index, value, form?.getFieldValue(`config[${index}]['priority']`)),
//         })(
//           <Select allowClear>
//             {availablePriorities?.map((item, index) => {
//               return (
//                 <Select.Option key={index} value={item}>
//                   {item}
//                 </Select.Option>
//               );
//             })}
//           </Select>
//         )}
//       </Form.Item>
//     );
//   };
  
  return [
    {
      title: "Account Details",
      key: "account_details",
      // width: 150,
      render: (record) => (
        <div>
          <Text4 className="d-block">{record.account_number}</Text4>
          <Text5 className="d-block" secondary>
            {record.account_ifsc}
          </Text5>
        </div>
      ),
    },
    {
      title: "Account Holder Name",
      key: "account_holder_name",
      // width: 230,
      render: (record) => <Text4>{record.account_holder_name}</Text4>,
    },
    {
      title: "Approval Status",
      key: "approval_status",
      // width: "",
      render: (record) => (
        <Badge
          color={SPLIT_APPROVAL_STATUS_TYPES[record?.approval_status.toLowerCase()]?.color}
          text={<Text4>{SPLIT_APPROVAL_STATUS_TYPES[record?.approval_status.toLowerCase()]?.label}</Text4>}
        />
      ),
    },
    // can_edit
    //   ? {
    //       title: "Split Value",
    //       key: "split_value",
    //       // width: 180,
    //       render: (item, record, index) => {
    //         const splitAccountIndex = splitAccounts.findIndex((accObj) => accObj.id === item.id);
    //         console.log('form.getFieldsValue() :>> ', form.getFieldsValue());
    //         let splitAcc = form.getFieldsValue()?.config ?? [];
    //         console.log('splitAcc ssss:>> ', splitAcc);
    //         if(!Array.isArray(splitAcc)) return;
    //         console.log('splitAcc :>> ', splitAcc);

    //         let lowestPriorityAcc = splitAcc?.find(
    //           (item) => item?.priority === splitAcc.length || splitAcc.length === 1
    //         );

    //         if (splitType === "percentage") lowestPriorityAcc = null;

    //         const splitValueValidator = (rule, value, split_type, callback) => {
    //           const regex = /^([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)$/;
    //           if (!regex.test(value)) {
    //             return callback("Enter Valid Value");
    //           }

    //           if (split_type === "percentage") {
    //             if (value > 100) callback("Enter Valid Percentage");
    //           }

    //           const maxDigitsRegex = /^\d{16}/;
    //           if (maxDigitsRegex.test(value)) {
    //             return callback("Split value must be less than 16 digits.");
    //           }
    //           callback();
    //         };

    //         const handleSplitValueInput = (val) => {
    //           const updatedVal = val.indexOf(".") >= 0 ? val.slice(0, val.indexOf(".") + 4) : val;
    //           return updatedVal;
    //         };

    //         const totalSplitPercentage = form.getFieldsValue().config?.reduce((total, obj) => {
    //           return parseFloat(total) + parseFloat(obj.split_value || 0);
    //         }, 0);

    //         return (
    //           <>
    //             {item.approval_status.toLowerCase() === "approved"
    //               ? getFieldDecorator(`config[${splitAccountIndex}]['id']`, {
    //                   initialValue: record.id,
    //                   preserve: true,
    //                 })(<Input autoComplete="off" hidden />)
    //               : null}

    //             {item.approval_status.toLowerCase() === "approved"
    //               ? getFieldDecorator(`config[${splitAccountIndex}]['rest_of_amount']`, {
    //                   initialValue: lowestPriorityAcc?.id === item?.id ? true : false,
    //                   preserve: true,
    //                 })(<Input autoComplete="off" hidden />)
    //               : null}
    //             {item.approval_status.toLowerCase() === "approved" ? (
    //               lowestPriorityAcc?.id !== item?.id ? (
    //                 <Form.Item className="text-align-center m-0">
    //                   {getFieldDecorator(`config[${splitAccountIndex}]['split_value']`, {
    //                     initialValue: isInitialSplitType ? parseFloat(record?.split_value).toFixed(3) : "0.000",
    //                     preserve: true,
    //                     rules: [
    //                       {
    //                         validator: (rule, value, callback) => {
    //                           splitValueValidator(rule, value, splitType, callback);
    //                         },
    //                       },
    //                     ],
    //                     normalize: handleSplitValueInput,
    //                   })(
    //                     <Input
    //                       disabled={lowestPriorityAcc?.id === item?.id}
    //                       prefix={splitType === "flat" ? `₹` : ""}
    //                       autoComplete="off"
    //                       suffix={splitType === "percentage" ? "%" : null}
    //                     />
    //                   )}
    //                 </Form.Item>
    //               ) : (
    //                 <span className="rest-of-amt-text">Rest Of The Amount</span>
    //               )
    //             ) : null}
    //           </>
    //         );
    //       },
    //     }
    //   : null,
    // {
    //   ...(splitType === "flat" && can_edit
    //     ? {
    //         title: "Precedence",
    //         key: "precedence",
    //         render: (item, record, index) => {
    //           const splitAccountIndex = splitAccounts.findIndex((accObj) => accObj.id === item.id);
    //           return item.approval_status.toLowerCase() === "approved"
    //             ? renderPriorityDropdown(record, splitAccountIndex)
    //             : null;
    //         },
    //       }
    //     : {}),
    // },
    {
      title: "Actions",
      render: (obj) => {
        return (
          <div className="text-center">
            {obj.approval_status.toLowerCase() !== "approved" ? (
              <Button type="link" onClick={() => actions.handleSplitUpdate(obj)}>
                <Icon type="edit" /> {"Edit"}
              </Button>
            ) : (
              "---"
            )}
          </div>
        );
      },
    },
  ];
};

export const getSplitAccountFilters = (defaultFilters) => {
  return [
    {
      label: "Account Number",
      field: "account_number",
      placeholder: "Enter Account Number",
      inputType: "text",
      defaultValue: "",
    },
    {
      label: "Account Holder Name",
      field: "account_holder_name",
      placeholder: "Enter Account Holder Name",
      inputType: "text",
      defaultValue: "",
    },
  ];
};

